import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './volumeCurveChartPreview.png';
import tablePreview from './volumeCurveTablePreview.png';
import { VolumeCurveHelpText } from './VolumeCurveHelp';

export const volumeCurveDescription: DropdownTooltipText = {
    body: <VolumeCurveHelpText />,
    previews: [
        { src: chartPreview, altText: 'volume-curve-chart-preview' },
        { src: tablePreview, altText: 'volume-curve-table-preview' },
    ],
};
